import { applyValueSetToImpactScoresByIVV } from '.';
import { computeNetScore } from '../../output/scores/compute-net-score';
import { ModelResultWithScores } from '../../output/scores/model-entity-data/types';
import { FinalImpactScoreType } from '../../output/scores/types';
import { ValueSetId } from './types';
import { nirValueSets, valueSets } from './value-sets';

export enum AlignmentLevel {
  WELL,
  SOMEWHAT,
  POOR,
}

export function toAlignmentLevel(netImpactRatio: number) {
  if (netImpactRatio < 0) {
    return AlignmentLevel.POOR;
  } else if (netImpactRatio < 0.3) {
    return AlignmentLevel.SOMEWHAT;
  } else {
    return AlignmentLevel.WELL;
  }
}

export function friendlyAlignmentLevel(level: AlignmentLevel) {
  switch (level) {
    case AlignmentLevel.WELL:
      return 'Well aligned';
    case AlignmentLevel.SOMEWHAT:
      return 'Somewhat aligned';
    case AlignmentLevel.POOR:
      return 'Poorly aligned';
  }
}

export function getNetImpactRatioInValueSet(
  result: ModelResultWithScores | undefined,
  valueSet: ValueSetId,
): number | undefined {
  const currentScore = pickScore(result, valueSet);
  return currentScore;
}

function pickScore(result: ModelResultWithScores | undefined, valueSetId: ValueSetId) {
  if (!result || !result.impactScoresByTIVV[FinalImpactScoreType.RELATIVE]) {
    return undefined;
  }
  const rawScores = result.impactScoresByTIVV[FinalImpactScoreType.RELATIVE];
  const valueSetScores = applyValueSetToImpactScoresByIVV(rawScores, getValueSet(valueSetId));
  return computeNetScore(valueSetScores, FinalImpactScoreType.RELATIVE);
}

function getValueSet(id: ValueSetId) {
  if (nirValueSets[id]) {
    return nirValueSets[id];
  }
  if (valueSets[id]) {
    return valueSets[id];
  }
  throw Error('Value set not found');
}

export function friendlyValuesAlignmentValueSetName(id: ValueSetId) {
  switch (id) {
    case ValueSetId.EQUAL_WEIGHTS:
      return 'Equally weighted impacts**';
    case ValueSetId.NIR_MILLENIAL:
      return 'Millennials';
    case ValueSetId.NIR_MOST_WANTED:
      return 'Most wanted workforce';
    case ValueSetId.NIR_FEMALE:
      return 'Females';
    case ValueSetId.NIR_ASSET_OWNER:
      return 'Asset owners';
  }
  return id;
}

export const defaultValuesAlignmentValueSets: ValueSetId[] = [
  ValueSetId.EQUAL_WEIGHTS,
  ValueSetId.NIR_MILLENIAL,
  ValueSetId.NIR_MOST_WANTED,
  ValueSetId.NIR_ASSET_OWNER,
];
